var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTheSebel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "284px",
    height: "284px",
    viewBox: "0 0 284 284",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "The Sebel Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.000400000001 41 27.0154 41 27.0154 0.4173 0.000400000001 0.4173 0.000400000001 41"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "(old)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "The-Sebel-Logo"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Page-1",
    fill: "#002F5F",
    points: "0 283.465 283.465 283.465 283.465 0 0 0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(45.000000, 106.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#D0A65A",
    points: "70.1685 0 70.1685 2.839 75.0805 2.839 75.0805 16.844 78.5805 16.844 78.5805 2.839 83.0285 2.839 83.8915 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#D0A65A",
    points: "101.3868 0 101.3868 6.779 93.5678 6.779 93.5678 0 90.0648 0 90.0648 16.844 93.5678 16.844 93.5678 9.764 101.3868 9.764 101.3868 16.844 104.8818 16.844 104.8818 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#D0A65A",
    points: "112.1364 0 112.1364 16.844 121.8554 16.844 121.8554 14.014 115.6484 14.014 115.6484 9.662 120.9904 9.662 120.9904 6.867 115.6484 6.867 115.6484 2.839 120.9904 2.839 121.8854 0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(0.000000, 30.821800)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.1234,31.2173 C5.6464,32.8843 8.6464,34.1563 12.1174,34.1563 C15.1934,34.1563 18.2484,33.0713 18.2484,30.0783 C18.2484,22.9293 1.3244,23.8303 1.3244,11.7043 C1.3244,5.7593 6.0704,0.4173 14.5904,0.4173 C18.7934,0.4173 22.3304,1.3823 24.6204,2.5193 L24.6204,9.9003 C21.1854,8.2123 17.9994,7.3153 14.8264,7.3153 C12.2974,7.3153 10.0824,8.2123 10.0824,10.9833 C10.0824,17.7013 27.0154,16.7453 27.0154,29.3463 C27.0154,36.5523 20.7134,41.0003 12.4214,41.0003 C7.8124,41.0003 3.1844,39.7373 0.000400000001,37.3943 L3.1234,31.2173 Z",
    id: "Fill-4",
    fill: "#D0A65A",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#D0A65A",
    points: "44.1932 0.8409 67.0692 0.8409 64.9652 7.4999 52.4102 7.4999 52.4102 16.9199 64.9652 16.9199 64.9652 23.5309 52.4102 23.5309 52.4102 33.7259 67.0012 33.7259 67.0012 40.3969 44.1932 40.3969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6897,33.6652 C102.2487,33.6652 104.5387,32.1072 104.5387,28.5092 C104.5387,25.4502 102.2487,23.7092 98.4647,23.7092 L93.4817,23.7092 L93.4817,33.6652 L97.6897,33.6652 Z M96.5987,16.9862 C100.2007,16.9862 102.0657,14.9462 102.0657,12.3592 C102.0657,9.6562 100.2677,7.5662 96.4267,7.5662 L93.4817,7.5662 L93.4817,16.9862 L96.5987,16.9862 Z M85.2487,0.8412 L97.6897,0.8412 C106.2677,0.8412 110.1137,5.8232 110.1137,10.8692 C110.1137,14.1042 108.4927,17.2942 105.4307,18.8382 L105.4307,18.9602 C110.1657,20.2212 112.8147,24.0742 112.8147,28.5092 C112.8147,34.5122 108.1377,40.3972 98.7647,40.3972 L85.2487,40.3972 L85.2487,0.8412 Z",
    id: "Fill-9",
    fill: "#D0A65A"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    fill: "#D0A65A",
    points: "128.9698 0.8409 151.8228 0.8409 149.7278 7.4999 137.1888 7.4999 137.1888 16.9199 149.7278 16.9199 149.7278 23.5309 137.1888 23.5309 137.1888 33.7259 151.7678 33.7259 151.7678 40.3969 128.9698 40.3969"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    fill: "#D0A65A",
    points: "170.014 0.8409 178.252 0.8409 178.252 33.7259 192.053 33.7259 192.053 40.3969 170.014 40.3969"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheSebel);
export default __webpack_public_path__ + "static/media/TheSebel.6925e5935ce1864b9eb0b905bc4b5330.svg";
export { ForwardRef as ReactComponent };